<template>
	<Modal :is-open="isOpen" @close="closeModal">
		<template v-slot:title>{{$t('modalAcess.title')}}</template>
	<div class="content--homeModal">
		<p v-html="$t('modalAcess.text')"></p>
	</div>
	<div class="buttons--wrap"> 
		<Button @interceptAccess="go(this.$router.resolve({name: 'signup'}).path, 'signup', '', -1)" type="primary" :buttonText="$t('buttons.fazerCadastro')" />
		<Button @interceptAccess="go(this.$router.resolve({name: 'signin'}).path, 'signin', '', -1)" type="secondary" :buttonText="$t('buttons.fazerLogin')" />
	</div>
	</Modal>
	<a class="cardBuscar" @click="interceptAccess(data, data.type, data.title, data.id)" :link="data[data.type]?.externalLink" :class="{'small': small}">	
		<img :src="getImage(data)" class="cardBuscar__image" />
		<div class="cardBuscar__body">
			<div class="cardBuscar--text">
				<div v-if="data.label" class="label">{{data.label}}</div>
				<strong>{{data.title}}</strong>
			</div>
		</div>
	</a>
	
</template>
<script>
import Button from '@/components/form/Button.vue';
import { googleAnalyticsParamEvent, googleAnalyticsEvent } from '../utils/googleAnalyticsEvents';


export default {
	components: {
		Button
	},
	props: {
		data : Object,
		small: Boolean,
		isLink: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			isOpen: false,
			FILE_TYPES: {
				IMAGE: 1,
				VIDEO: 2,
				DOCUMENT: 3,
				AUDIO: 4,
			}
		}
	},
	computed:{
		login : function(){
			return {
				name: this.$store.state.auth.user?.name,
				logged: !!this.$store.state.auth.user
			}
		}
	},
	methods: {
		go(to){
			this.isOpen = false
			this.$router.push(to)
		},
		interceptAccess(data, element, content, index){
			let to = ''
			switch(data?.type){
				case 'saleOffer':
					to = data[data.type]?.externalLink;
					break;
				case 'productLaunch':
					to = data[data.type]?.externalLink;
					break;
				case 'tutorial':
                    to = this.$router.resolve({ 
							name: 'tutorial-detalhe',
							params: { slug: data?.linkName }  
						}).path;
					break;
				case 'promocao':
					to = data?.link;
					break;
				default:
					to = data[data.type]?.externalLink;
					break;
			}

			this.$store.dispatch('route/click', { to, element, content, index })
			.catch(e => {
				this.isOpen = true
			})

			// if(this.login.logged)
			// 	if(!(typeof to == 'object') && to.indexOf('https') >= 0){
			// 		googleAnalyticsEvent(['lgfamilyclub', element, content, index, to])
			// 		window.open(to, '_blank')
			// 	}else{
			// 		googleAnalyticsEvent(['lgfamilyclub', element, content, index, window.location.host+to])
			// 		this.$router.push(to)
			// 	}
			// else if (['/entrar', '/cadastre-se'].includes(to) || (to.hasOwnProperty('path')?to.path.indexOf('/buscar') >= 0:to.indexOf('/buscar') >= 0)){
			// 	googleAnalyticsEvent(['lgfamilyclub', element, content, index, window.location.host+to])
			// 	this.$router.push(to)
			// }else{
			// 	this.isOpen = true
			// }
		},
		closeModal(){
			this.isOpen = false
		},
		getImage(data){
			const type = data.type
			const typeFiles = type+'Files'
			const fileTypeId = type+'FileTypeId'
			const aux = data[type]
			const files = data[type]?aux[typeFiles] || []: []
			if(!files || files.length <= 0)
				return ''
			const file = files.find(file => file[fileTypeId] === this.FILE_TYPES.IMAGE)
			return import.meta.env.VITE_APP_API_URL+'files/render/'+file.file.name
		},
	}
}
</script>
<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *



.cardBuscar
	background-color: #fff
	border-radius: 15px
	color: #454546
	text-decoration: none
	display: flex
	flex-direction: column

	&:hover
		box-shadow: 0px 0px 0px 1px var(--lg-red-active)

	&.small
		strong
			max-width: 100%
			font-size: 1.25rem
			font-weight: 400

		picture
			border-radius: 15px

	.label
		color: #f26628
		border: 1px solid #f26628
		border-radius: 5px
		background-color: #fff
		text-transform: uppercase
		padding: 3px 20px
		display: inline-block
		margin-bottom: 10px
		font-weight: 600

	picture
		max-height: 230px
		border-radius: 15px 15px 0 0
		overflow: hidden

	&__image
		width: 100%
		// height: 230px
		object-fit: fill
		border-radius: 15px 15px 0 0

		img
			width: 100%

	&__body
		padding: 20px 25px
		display: flex
		flex-direction: column
		align-items: flex-start
		// height: 100%
		flex-grow: 1
		justify-content: space-between
		
		.buttonApp
			margin-top: 1rem !important
	

		strong
			@include line-limited (3)
			font-size: 1.0625rem
			

</style>
